import { RealTimeAction } from '@/_core/fluxstore/types';
import { MoveCardResult } from '../../../api/commands';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer } = useStorymapStore();

export class HandleMoveCardResult extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'HandleMoveCardResult';

    public constructor(public res: MoveCardResult) {
        super(HandleMoveCardResult.ACTION_TYPE);
    }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const reducer = (state: StorymapState, action: HandleMoveCardResult): void => {
    if (action.res.PushedActivity != null) {
        const activity = state.activities.find(x => x.id == action.res.PushedActivity.Id);
        activity.linkedUrl = action.res.PushedActivity.LinkedItemUrl;
        activity.isLinkedToIntegrationTool = true;
    }

    if (action.res.PushedTask != null) {
        const task = state.tasks.find(x => x.id == action.res.PushedTask.Id);
        task.linkedUrl = action.res.PushedTask.LinkedItemUrl;
        task.isLinkedToIntegrationTool = true;
    }

    if (action.res.UnlinkedCardIds != null) {
        const allCards = [...state.activities, ...state.tasks, ...state.subtasks];
        for (const unlinkedId of action.res.UnlinkedCardIds) {
            const card = allCards.find(x => x.id == unlinkedId);
            if (card) {
                card.isLinkedToIntegrationTool = false;
                card.linkedUrl = '';
                card.linkedItemKey = '';
            }
        }
    }
};

//@ts-ignore
registerReducer(HandleMoveCardResult.ACTION_TYPE, reducer);
